import React, { useEffect, useState } from 'react';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { StyledContainer } from '../styles';
import type { InputCheckboxListProps } from '../types';

import InputCheckboxListControl from './InputCheckboxListControl';
export default function InputCheckboxList<T extends FieldValues>({
  control,
  label,
  name,
  options,
  setValue,
  ...props
}: InputCheckboxListProps<T>) {
  const [selectedOptions] = useState<InputOption[]>([]);

  useEffect(() => {
    setValue?.(name, selectedOptions);
  }, [name, selectedOptions, setValue]);

  return (
    <StyledContainer {...props}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <InputCheckboxListControl
            label={label}
            options={options}
            setValue={setValue}
            {...field}
          />
        )}
      />
    </StyledContainer>
  );
}
